<template>
    <div>
      <CRow>
        <CCol xs="12" sm="12" md="12" lg="4" xl="3">
          <CCard>
            <CCardHeader class="d-flex justify-content-between">
              <b><i class="fas fa-calendar"></i>&nbsp;Citas</b>
            </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol xs="12" sm="4" md="4" lg="12" xxl="12">
                  <CInput label="Desde" type="date" aria-label="shift_date" @input="mtd_data" size="sm" id="init"
                    v-model="filter.init" />
                </CCol>
                <CCol xs="12" sm="4" md="4" lg="12" xxl="12">
                  <CInput label="Hasta" type="date" aria-label="shift_date" @input="mtd_data" id="end" size="sm"
                    v-model="filter.end" />
                </CCol>
                <CCol xs="12" sm="4" md="4" lg="12" xxl="12">
                  <CInput label="Total de Citas" type="text" size="sm" v-model="totalCitas" disabled />
                </CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>
        <CCol xs="12" sm="12" md="12" lg="8" xl="9">
          <CTableWrapper :items="data" :fields="fields" hover :striped="true" :border="true" small fixed
            caption="Lista de Citas" icon="fas fa-coins" @mtdBack="mtdBack" :size="'md'" :withActions="'2%'">
          </CTableWrapper>
        </CCol>
      </CRow>
  
    </div>
  </template>
  
  <script>
  const fields = [
    { key: "index", label: "Id", _style: "width:1%" },
    { key: "name_client", label: "Cliente", _style: "width:10%;" },
    { key: "barbers", label: "Personal", _style: "width:10%;" },
    { key: "date_formatted", label: "fecha", _style: "width:10%;" },
    { key: "hour", label: "Inicio", _style: "width:10%;" },
    { key: "completed_hour", label: "Terminado", _style: "width:10%;" },
    { key: "services", label: "Sevicios/Productos", _style: "width:10%;" },
    { key: "subtotal", label: "Subtotal", _style: "width:10%;" },
    { key: "ajustment_amount", label: "Aumento /Descuento", _style: "width:10%;" },
    { key: "all_total", label: "Total", _style: "width:10%;" },
    { key: "status", label: "Estado", _style: "width:5%;" },
    // { key: "method_payment_text", label: "Método de pago", _style: "width:5%;" },
  ];
  
  import CTableWrapper from "../../components/shared/datatable/Table.vue";
  import CModalForm from "../../components/shared/modals/cModalForm.vue";
  import cModalDelete from "../../components/shared/modals/cModalDelete.vue";
  import { mapActions } from "vuex";
  import cSelectForm from "../../components/shared/inputs/cSelect.vue";
  import moment from "moment";
  
  export default {
    components: {
      CTableWrapper,
      CModalForm,
      cModalDelete,
      cSelectForm,
    },
    data() {
      return {
        prefix: "cita",
        fields,
        data: [],
        totalCitas: 0,
        dataBarbers: [],
        filter: {
          init: null,
          end: null,
        },
  
        labelIcon: {
          labelOn: "\u2713",
          labelOff: "\u2715",
        },
        componentKey: 0,
      };
    },
    computed: {
      cpStatus: function () {
        if (this.companies.state == 1) return true;
        return false;
      },
    },
    created() {
      moment.locale("es");
      this.filter.end = moment().format("YYYY-MM-DD");
      this.filter.init = this.filter.end;
      this.mtd_data();
    },
    methods: {
      ...mapActions(["get", "post"]),
      mtd_data() {
        if (!this.filter.init || !this.filter.end || this.filter.init > this.filter.end) {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Por favor, selecciona un rango de fechas válido.',
          });
        }
        this.post({
          url: this.$store.getters.get__url + "/" + this.prefix + "/dragable",
          token: this.$store.getters.get__token,
          params: {
            init: this.filter.init,
            end: this.filter.end,
            campu_id: this.$store.getters.get_campu.id,
            company_id: this.$store.getters.get_company.id,
          },
        })
          .then((response) => {
            this.data = response.data.data;
            this.totalCitas = this.data.length;
            let index = 1;
            this.data.forEach((item) => {
              item.index = index++;
              item.barbers = item.barber_detail && item.barber_detail.length > 0 ? 
                              item.barber_detail.map(det => det.barber ? det.barber.name + " " + det.barber.last_name : 'Personal desconocido').join(", ") : 'No existe Personal';
              item.date_formatted = moment(item.date).format("DD/MM/YYYY");
              item.completed_hour = item.completed_hour ?? "-";
              let services = item.detail.map(detail => detail.name_service);
              if (item.detail_product) {
                let detailProduct = JSON.parse(item.detail_product);
                let productNames = detailProduct.map(product => product.name);
                services = services.concat(productNames);
              }
              item.services = services.join(", ");

              if (item.sale && item.sale.method_payment && item.sale.method_payment.name) {
                item.method_payment_text = item.sale.method_payment.name;
              } else {
                item.method_payment_text = 'No especificado';
              };
              switch (item.state) {
                case 1:
                  item.status = "Reservado";
                  break;
                case 2:
                  item.status = "En curso";
                  break;
                case 3:
                  item.status = "Terminado";
                  break;
                default:
                  item.status = "Desconocido";
              };
              item.subtotal = item.total;
              item.all_total = (parseFloat(item.total) + parseFloat(item.ajustment_amount)).toFixed(2);
            });
          })
          .catch((errors) => {
            Swal.fire({
              title: errors,
              icon: "danger",
            });
          });
      },
      mtdBack: function () {
        this.$emit("mtdBack");
      },
    },
  
  };
  </script>
  
  <style lang="scss" scoped></style>